import { useEffect, useState } from "react";
import type { ReactElement } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { apiClient } from "../api/client";
import { useAuth } from "../contexts/AuthContext";

export function InvitePage(): ReactElement {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [status, setStatus] = useState<"loading" | "error">("loading");
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setError("Токен не указан");
      return;
    }

    (async () => {
      try {
        await apiClient.get(`/auth/invite/${token}`);
        await refresh();
        navigate("/catalog", { replace: true });
      } catch (err: unknown) {
        setStatus("error");
        const detail =
          (err as { response?: { data?: { detail?: string } } }).response?.data?.detail ??
          "Не удалось активировать invite";
        setError(detail);
      }
    })();
  }, [token, refresh, navigate]);

  if (status === "loading") {
    return (
      <section className="auth-card">
        <h1>Активация invite…</h1>
        <p>Пожалуйста, подождите.</p>
      </section>
    );
  }

  return (
    <section className="auth-card">
      <h1>Ошибка активации</h1>
      <p className="auth-error">{error}</p>
      <p>
        Возможные причины: invite истёк, был отозван менеджером, или ссылка
        некорректна. Пожалуйста, свяжитесь с вашим менеджером в IT-Navigate.
      </p>
    </section>
  );
}
